import React, {useState} from "react";
import '../TasksNode/TasksNode.scss';
//import DataLibraryClient from "../Library/DataLibraryClient/DataLibraryClient";
import { renderDonutChart } from "../../../../utils/donutChartFunction";
import { getTaskDataMain, viewStartedForm, setStartedForStartedForm, setTaskIdForStartedForm, setValueForStartedForm } from "../../Tasks/taskSlice";
import logoPath from '../../../../styles/svg_tasks/svg_path.svg';
import logoPathDisable from '../../../../styles/svg_tasks/svg_path_disable.svg';
//import StartedForm from "../StartedForm";
import { closeAllView,  getInitialStateWithPreviousView,  
    showView, setPreviousModule } from "../../../Menu/MenuSide/menuSideSlice";
import { quizSetId, quizSetName, quizLoad, getInitialState } from "../../Quiz/quizSlice";
import { setSelectedNoteId, setSelectedNoteName } from "../../Notes/noteslice";
import { idNoteLoad } from "../../../Admin/adminSlice";

const TasksNode = (props) => {
       const [openContentForTask, setOpenContentForTask] = useState(false);
       const [idTask, setIdTask] = useState(0);
     // const [itemForStarted, setItemForStarted] = useState({});
      //const [taskIdForStarted, setTaskIdForStarted] = useState(0);
     // const [startedForStarted, setStartedForStarted] = useState(false);

   const {dispatch} = props;

// ON CLICK START TASK
const onClickStartTask = (e) => {
    
   const selectedTaskId = Number(e.target.value);
   const startedValueString = e.target.dataset.value1;
   //REVERSE DISABLE
   //console.log(startedValueString);
   const startedValue = true ? startedValueString === 'true' : false;

    const item = {
        taskId: selectedTaskId,
        started: !startedValue,
    }
   
   // console.log(item);
    dispatch(setTaskIdForStartedForm(item.taskId));
    dispatch(setStartedForStartedForm(item.started));
    dispatch(setValueForStartedForm(startedValue)); //TASK STOPED OR STARTED

    dispatch(viewStartedForm());  
    //console.log(item);
   
}
//SHOW INFORMATION FOR TASK
const onClickShowInformation = (e) => {
    console.log('show information');
}

// ONCLICK  MAIN TASK
    const onClickMainTask = (e) => {


        //console.log('WORK SHOW MAIN TASKS');
        
    
        const selectedTaskId = Number(e.target.value);
        let tasksDataMain = props.tasksDataMain;
        console.log(selectedTaskId);

        setIdTask(selectedTaskId);

        
        if (tasksDataMain.length !== 0) {

                //CHECK IF EXIST IN DATA
            const findTaskId = (selectedId, data ) => {
                const result = data.findIndex(({taskId}) => taskId === selectedId);
                return result;
            }
            const result = findTaskId(selectedTaskId, tasksDataMain);
             console.log(result);
            
                if (result === -1) {
                    // console.log(e.currentTarget.value);
                    console.log('START GET TASK');
                    dispatch(getTaskDataMain(selectedTaskId));
                    setOpenContentForTask(!openContentForTask);
                    // console.log(selectedQuizId);
                    } else {setOpenContentForTask(!openContentForTask);}
        
            } else {
            
            dispatch(getTaskDataMain(selectedTaskId));
            setOpenContentForTask(!openContentForTask);
        }

        
    }
// ONCLICK QUIZE
const onClickQuiz = (e) => {
        console.log('show quize');
        dispatch(closeAllView());
    
        const selectedQuizId = Number(e.target.value);
        const selectedItem = e.target.dataset.value1;
        //console.log(selectedItem);
       
        //FIND NAME QUIZ
        
        ;
        dispatch(getInitialState());
        dispatch(getInitialStateWithPreviousView());
        dispatch(setPreviousModule());
        dispatch(showView("3"));
        
        dispatch(quizSetId(selectedQuizId));
        dispatch(quizSetName(selectedItem));
        dispatch(quizLoad(selectedQuizId));
}
// ONCLICK NOTE
const onClickNote = (e) => {
     const dataNotes = props.dataNotes;    
            console.log('WORK SHOW NOTES');
            dispatch(closeAllView());
    
            const selectedNoteId = Number(e.target.value);
            
           
            //FIND NAME QUIZ
           
            const selectedItem = e.target.dataset.value1;
    
            const findNote = (dataNotes) => {
                const result = dataNotes.findIndex(item => item.id === selectedNoteId);
                return result;
            };
           
            const noteExist = findNote(dataNotes);
            
        //console.log(noteExist);
    
            if (noteExist === -1) {
    
                console.log('Load NEW notes');
    
                dispatch(setSelectedNoteId(selectedNoteId));
                dispatch(setSelectedNoteName(selectedItem));
                dispatch(idNoteLoad(selectedNoteId));
               // dispatch(getInitialStateMenu());
               // dispatch(showNotes());
               dispatch(getInitialStateWithPreviousView());
               dispatch(setPreviousModule());
               dispatch(showView(33));
            } else {
                dispatch(setSelectedNoteId(selectedNoteId));
                dispatch(setSelectedNoteName(selectedItem));
               // dispatch(getInitialStateMenu());
                //dispatch(showNotes());
                dispatch(getInitialStateWithPreviousView());
                dispatch(setPreviousModule());
                dispatch(showView(33));
            }



}


    //RENDER TASK DATA
    
    const renderContentForTask = (taskDisable) => {

         // array of data answers

        let tasksDataMain = props.tasksDataMain;
        console.log(tasksDataMain);
        //console.log(typeof(idTrouble));
        
        //FIND CONTENT FOR TASK
        let resultArrayTaskData = [];
            if (tasksDataMain.length !== 0) {
                tasksDataMain.forEach(element => {
                    
                if (element.taskId === idTask) {
                    resultArrayTaskData.push(element);
                }

                }); 
            };
             console.log(resultArrayTaskData);
             
                
             //RENDER CONTENT FOR TASK

                    if (resultArrayTaskData.length !== 0) {
                        let contentForTask = resultArrayTaskData[0].taskData;
                        console.log(contentForTask);
                       
                        //STYLE BUTTON IF DISABLE
                        let stylePathLogo;
                        let styleQuizLogo;
                        let styleNoteLogo;
                        let styleTroubleLogo;
                        let styleDisabled;

                        if (taskDisable) {
                            stylePathLogo = logoPath;
                            styleQuizLogo = 'quiz';
                            styleNoteLogo = 'note';
                            styleTroubleLogo = 'trouble';
                            styleDisabled = '';
                        } else {
                            stylePathLogo = logoPathDisable;
                            styleQuizLogo = 'quiz-disable';
                            styleNoteLogo = 'note-disable';
                            styleTroubleLogo = 'trouble-disable';
                            styleDisabled = 'disabled';
                        }


                        //CHECK IF USERS TASKS STARTED


                        return (
                            
                           
                            contentForTask.map( (item, index) => {
                                console.log(item);
                                
                            return (

                                <div className="answerBox" key={index}>
                                    <div className="text-block">
                                    <img src={stylePathLogo} className="logo-path" alt="logoPath" />
                                    <div className="index-name"> #{item.quiz_id}</div>
                                    
                                    <div className="title">{item.quiz_name}</div>
                                    
                                    </div>

                                    <div className="button-block">
                                        <div className="user">{item.publisher}</div>
                                        <div className="td-button"><button className={styleQuizLogo} value={item.quiz_id} data-value1={item.quiz_name} onClick={onClickQuiz} disabled={styleDisabled}></button></div>
                                        <div className="td-button"><button className={styleNoteLogo} value={item.quiz_id} data-value1={item.quiz_name} onClick={onClickNote} disabled={styleDisabled}></button></div>
                                        {(props.authData.modulesName[1].status || (props.authData.userRole[0].role_id === 1)) ? <div className="td-button"><button className={styleTroubleLogo} disabled={styleDisabled}></button></div> : null}
                                        <div className="donut-chart-container">{taskDisable ? renderDonutChart(Math.round(item.quiz_resolved ? item.quiz_resolved : 0)) : renderDonutChart(Math.round(0))}</div>
                                        <div className="td-center">{taskDisable ? Math.round(item.quiz_resolved ? item.quiz_resolved : 0 ) : Math.round(0) }%</div>
                                    </div>                                    
                                    
                                </div>
                            )
                            })

                        )
                            
                        } else return null;
                    
    }


//RENDER TABLE MAIN TASKS
   const renderMainTasksTable = () => {
    let  taskItem =  props.element;
    //console.log(taskItem);

    //FIND TASK
    let taskDisable;
    const findUserTaskId = (selectedId, data ) => {
        const result = data.findIndex(({task_id}) => task_id === selectedId);
        return result;
    };
    
    if (props.tasksData.userTasks.length !== 0) {
    const index =findUserTaskId(taskItem.task_id, props.tasksData.userTasks);
   
    //console.log(taskItem.task_id);
    //console.log(props.tasksData.userTasks);
    //console.log(index);

        if (index !== -1) {

            if (props.tasksData.userTasks[index].started) {
                taskDisable = true;
            } else {
                taskDisable = false;
            }
            
        } else {
            taskDisable = false;

        }
    }
     else {
        taskDisable = false;
    }


    let style;
    let styleStartButton;
    if (taskDisable) {
              
        style = 'task-button';
        styleStartButton = 'task-stop';
    } else {
        style = 'task-button-beforestart';
        styleStartButton = 'task-start';
    }

const priceElement = <div className="price-block">
    <p className="price">{taskItem.price}</p><span className="rub"> ₽</span>
    </div> ;

    return (
       
           // console.log(item.task_id);
            
                <div className="main-tr"  >
                    <div className='tr-item' >
                        <div className="number">#{taskItem.task_id}</div>
                        <div className="title" ><button className ={style} value={taskItem.task_id} onClick={onClickMainTask} >{taskItem.title} 
                            <span className={taskItem.public ? "status-note" : "status-note-private" }>{taskItem.public ? 'public' : 'private'}</span></button></div>
                        <div className="button-block" >
                            
                            <div className="td-button">
                                <button  value={taskItem.task_id}   onClick={onClickShowInformation} >i</button>
                                {taskItem.paid ? priceElement: null}
                                <button className={styleStartButton} value={taskItem.task_id}  data-value1={taskDisable} onClick={onClickStartTask} ></button>
                                
                            </div>
                            
                            
                        
                        </div>
                        
                        
                    </div>
                {openContentForTask ? renderContentForTask(taskDisable): null}
                </div>
                
            
        )    
   }


    //RENDER
    
    
        return (
            <div className="TasksNode" >
                                          
                               {renderMainTasksTable()} 
                               
               
            </div>
        );
    
}
export default TasksNode;